var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorseLogoGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1194 620",
    style: {
      enableBackground: "new 0 0 1194 620"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000001651946196718034370000001258903188718374303_);fill:#354334;}\n\t.st1{clip-path:url(#SVGID_00000001651946196718034370000001258903188718374303_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 64.2,
    y: 94.4,
    width: 1088.8,
    height: 424.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182505951525779210490000005011845117554666902_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    d: "M524.3,382.9 l-69.5-90.1c-1.9-2.8-3.7-5.7-3.9-6.1c0,0.2,0.4,4,0.4,7.6v88.6h-34.5V228.2h29.7l69.5,89.2c2.2,2.8,3.7,5.7,3.9,6.4 c0-0.2-0.4-4-0.4-7.8v-87.8h34.5v154.7H524.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    d: "M857.3,382.9 l-43.8-73.1v73.1H779V228.2h56.5c33,0,54.1,19.5,54.1,46.2c0,23.1-14.4,38.4-35.1,43.9l41.8,64.6H857.3z M835.5,256.8h-22v37.3h22 c12.1,0,19.6-7.6,19.6-19.7C855.2,263.6,846.5,256.8,835.5,256.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    d: "M973.4,386.9 c-21.8,0-37.7-7.8-52.8-19.3l17.9-23.7c9.3,7.2,22.7,13.3,35.6,13.3c15.7,0,20.1-5.3,20.1-14.6c0-15.5-28.7-20.8-41.9-28 c-15.7-8.5-28.3-18.2-28.3-42.8c0-31.8,28.3-44.7,56.1-44.7c14.9,0,32.8,4,45.5,13.3l-15.5,25.2c-6.9-5.1-18.5-8.9-30-8.9 c-16,0-21.6,8.9-21.6,15.1c0,14,20.1,18.2,38.4,26.1c15.3,6.6,31.7,17.2,31.7,42.6C1028.6,369.8,1007.5,386.9,973.4,386.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    points: "1058.1,381.9  1058.1,227.1 1149.8,227.1 1149.8,255.7 1092.6,255.7 1092.6,292 1145.6,292 1145.6,320.6 1092.6,320.6 1092.6,353.2 1153,353.2  1153,381.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M85,562.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5H68v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C85.8,561.1,85.5,562,85,562.9 M82.4,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4H68v12.7h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M142,578.2L131.8,566 h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v2.3 c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5l10.2,12.2H142z M141.6,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.4v11.5h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M204.4,574.3 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.6-3.6,0.6h-2.7c-1.3,0-2.5-0.2-3.6-0.6c-1.1-0.4-2.1-0.9-2.9-1.5 c-0.8-0.7-1.5-1.4-2-2.2c-0.5-0.8-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,2.9-1.5 c1.1-0.4,2.3-0.5,3.6-0.5h2.7c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v15.4 C205.1,572.5,204.9,573.4,204.4,574.3 M201.8,556.2c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1 c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8 v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.6,0.7,1,1.3,1.5c0.6,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.3,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4 c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.2,0.5-1.8V556.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M265.8,562.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-3,1.5c-1.1,0.4-2.3,0.5-3.6,0.5h-8.5v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,3,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C266.5,561.1,266.3,562,265.8,562.9 M263.1,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.3v12.7h8.3 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "305.1,578.2  305.1,549.6 326.3,549.6 326.3,552 308.5,552 308.5,562.7 322.9,562.7 322.9,565.1 308.5,565.1 308.5,575.7 326.3,575.7  326.3,578.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M382.5,578.2L372.3,566 h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v2.3 c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5l10.2,12.2H382.5z M382.1,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.4v11.5h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "434.2,552  434.2,578.2 430.8,578.2 430.8,552 421.8,552 421.8,549.6 443.1,549.6 443.1,552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "490.5,564.5  490.5,578.2 487.2,578.2 487.2,564.5 477.4,549.6 481.1,549.6 488.8,561.5 496.5,549.6 500.2,549.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "605.4,578.2  605.4,558.6 605.1,559.8 596.4,578.2 594.6,578.2 585.8,559.8 585.6,558.6 585.6,578.2 582.2,578.2 582.2,549.6 584,549.6  595.4,573 595.5,574.1 595.6,573 607,549.6 608.7,549.6 608.7,578.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M663.5,571.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6H666L663.5,571.5z M652.6,569.1h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L652.6,569.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "725.9,578.2  710.2,557.3 709.9,556.1 709.9,578.2 706.5,578.2 706.5,549.6 708.3,549.6 723.9,570.4 724.3,571.6 724.3,549.6 727.7,549.6  727.7,578.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M782.5,571.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6H785L782.5,571.5z M771.5,569.1h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L771.5,569.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M846,578.2H845l-2-2.3 c-0.8,0.8-1.8,1.5-3,2c-1.2,0.5-2.5,0.7-3.9,0.7h-2c-1.3,0-2.5-0.2-3.6-0.5c-1.1-0.4-2.1-0.9-3-1.5c-0.8-0.6-1.5-1.4-2-2.2 c-0.5-0.9-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,3-1.5c1.1-0.4,2.3-0.5,3.6-0.5h2.7 c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.9,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v1.2l-3.4,0.4v-1.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.4,0.4 c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.5,0.7,1,1.3,1.5 c0.5,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.4,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5 c0.3-0.6,0.5-1.2,0.5-1.8v-6h-6v-2.4h9.4V578.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "886.3,578.2  886.3,549.6 907.4,549.6 907.4,552 889.7,552 889.7,562.7 904,562.7 904,565.1 889.7,565.1 889.7,575.7 907.4,575.7 907.4,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "969.2,578.2  969.2,558.6 968.9,559.8 960.2,578.2 958.4,578.2 949.6,559.8 949.4,558.6 949.4,578.2 946,578.2 946,549.6 947.8,549.6 959.2,573  959.3,574.1 959.4,573 970.8,549.6 972.5,549.6 972.5,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "1013.3,578.2  1013.3,549.6 1034.4,549.6 1034.4,552 1016.7,552 1016.7,562.7 1031,562.7 1031,565.1 1016.7,565.1 1016.7,575.7 1034.4,575.7  1034.4,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "1092.4,578.2  1076.7,557.3 1076.4,556.1 1076.4,578.2 1073,578.2 1073,549.6 1074.8,549.6 1090.4,570.4 1090.8,571.6 1090.8,549.6 1094.2,549.6  1094.2,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "1144,552  1144,578.2 1140.7,578.2 1140.7,552 1131.7,552 1131.7,549.6 1153,549.6 1153,552  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    d: "M665.4,383.9 c-48.8,0-80.9-36.5-80.9-80.5c0-44.5,32.6-79.3,81.3-79.3c49.2,0,80.9,33.3,80.9,79.3C746.7,348.1,714.1,383.9,665.4,383.9  M665.8,253.7c-27,0-45.7,23.7-45.7,49.6c0,28.4,20.7,50.9,45.3,50.9c28.5,0,45.7-24.8,45.7-50.9 C711.1,276.2,693.2,253.7,665.8,253.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M85,562.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5H68v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C85.8,561.1,85.5,562,85,562.9 M82.4,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4H68v12.7h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M142,578.2L131.8,566 h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v2.3 c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5l10.2,12.2H142z M141.6,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.4v11.5h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M204.4,574.3 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.6-3.6,0.6h-2.7c-1.3,0-2.5-0.2-3.6-0.6c-1.1-0.4-2.1-0.9-2.9-1.5 c-0.8-0.7-1.5-1.4-2-2.2c-0.5-0.8-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,2.9-1.5 c1.1-0.4,2.3-0.5,3.6-0.5h2.7c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v15.4 C205.1,572.5,204.9,573.4,204.4,574.3 M201.8,556.2c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1 c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8 v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.6,0.7,1,1.3,1.5c0.6,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.3,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4 c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.2,0.5-1.8V556.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M265.8,562.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-3,1.5c-1.1,0.4-2.3,0.5-3.6,0.5h-8.5v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,3,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C266.5,561.1,266.3,562,265.8,562.9 M263.1,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.3v12.7h8.3 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "305.1,578.2  305.1,549.6 326.3,549.6 326.3,552 308.5,552 308.5,562.7 322.9,562.7 322.9,565.1 308.5,565.1 308.5,575.7 326.3,575.7  326.3,578.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M382.5,578.2L372.3,566 h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v2.3 c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5l10.2,12.2H382.5z M382.1,556.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.4v11.5h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V556.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "434.2,552  434.2,578.2 430.8,578.2 430.8,552 421.8,552 421.8,549.6 443.1,549.6 443.1,552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "490.5,564.5  490.5,578.2 487.2,578.2 487.2,564.5 477.4,549.6 481.1,549.6 488.8,561.5 496.5,549.6 500.2,549.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "605.4,578.2  605.4,558.6 605.1,559.8 596.4,578.2 594.6,578.2 585.8,559.8 585.6,558.6 585.6,578.2 582.2,578.2 582.2,549.6 584,549.6  595.4,573 595.5,574.1 595.6,573 607,549.6 608.7,549.6 608.7,578.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M663.5,571.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6H666L663.5,571.5z M652.6,569.1h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L652.6,569.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "725.9,578.2  710.2,557.3 709.9,556.1 709.9,578.2 706.5,578.2 706.5,549.6 708.3,549.6 723.9,570.4 724.3,571.6 724.3,549.6 727.7,549.6  727.7,578.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M782.5,571.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6H785L782.5,571.5z M771.5,569.1h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L771.5,569.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    d: "M846,578.2H845l-2-2.3 c-0.8,0.8-1.8,1.5-3,2c-1.2,0.5-2.5,0.7-3.9,0.7h-2c-1.3,0-2.5-0.2-3.6-0.5c-1.1-0.4-2.1-0.9-3-1.5c-0.8-0.6-1.5-1.4-2-2.2 c-0.5-0.9-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,3-1.5c1.1-0.4,2.3-0.5,3.6-0.5h2.7 c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.9,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v1.2l-3.4,0.4v-1.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.4,0.4 c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.5,0.7,1,1.3,1.5 c0.5,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.4,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5 c0.3-0.6,0.5-1.2,0.5-1.8v-6h-6v-2.4h9.4V578.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "886.3,578.2  886.3,549.6 907.4,549.6 907.4,552 889.7,552 889.7,562.7 904,562.7 904,565.1 889.7,565.1 889.7,575.7 907.4,575.7 907.4,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "969.2,578.2  969.2,558.6 968.9,559.8 960.2,578.2 958.4,578.2 949.6,559.8 949.4,558.6 949.4,578.2 946,578.2 946,549.6 947.8,549.6 959.2,573  959.3,574.1 959.4,573 970.8,549.6 972.5,549.6 972.5,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "1013.3,578.2  1013.3,549.6 1034.4,549.6 1034.4,552 1016.7,552 1016.7,562.7 1031,562.7 1031,565.1 1016.7,565.1 1016.7,575.7 1034.4,575.7  1034.4,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "1092.4,578.2  1076.7,557.3 1076.4,556.1 1076.4,578.2 1073,578.2 1073,549.6 1074.8,549.6 1090.4,570.4 1090.8,571.6 1090.8,549.6 1094.2,549.6  1094.2,578.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#FFFFFF"
    },
    points: "1144,552  1144,578.2 1140.7,578.2 1140.7,552 1131.7,552 1131.7,549.6 1153,549.6 1153,552  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.9,
    y: 224.1,
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    width: 56.4,
    height: 292.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 223.7,
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    width: 56.4,
    height: 163.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.5,
    y: 94.4,
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    width: 56.4,
    height: 292.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    points: "69.5,454.3  69.5,156.8 247,156.7 247,151.5 64.2,151.5 64.2,459.5 90.9,459.5 90.9,454.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000182505951525779210490000005011845117554666902_)",
      fill: "#354334"
    },
    points: "374,151.5  347,151.5 347,156.8 368.7,156.8 368.7,454.3 191.3,454.3 191.3,459.5 374,459.5  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorseLogoGreen);
export default __webpack_public_path__ + "static/media/norse-logo-green.b9c7b0144702a6736f6d4df5a5f29a48.svg";
export { ForwardRef as ReactComponent };